(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products-scroll-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('yoko-product-rail')) return;
  customElements.define('yoko-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.yoko-product-rail__track');
      this.controls = this.querySelector('.yoko-product-rail__controls');
      if (!this.track || !this.controls) return;
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.interacted = false;
      const markInteracted = () => { this.interacted = true; };
      const resetInitialPosition = () => {
        if (this.interacted) return;
        if (Math.abs(this.track.scrollLeft) > 0) this.track.scrollTo({ left: 0, behavior: 'instant' });
        this.update();
      };
      /* Keep the first card in place while fonts, images and app widgets settle.
         Never reset a position the visitor has chosen by touch, mouse or keyboard. */
      this.addEventListener('pointerdown', markInteracted, { passive: true, capture: true, signal });
      this.addEventListener('touchstart', markInteracted, { passive: true, capture: true, signal });
      this.addEventListener('wheel', markInteracted, { passive: true, capture: true, signal });
      this.addEventListener('keydown', markInteracted, { capture: true, signal });
      this.addEventListener('focusin', markInteracted, { signal });
      window.addEventListener('load', resetInitialPosition, { once: true, signal });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) resetInitialPosition();
      }, { signal });
      resetInitialPosition();
      const move = (direction) => {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * rtl * (card.getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.prev.addEventListener('click', () => move(-1), { signal });
      this.next.addEventListener('click', () => move(1), { signal });
      this.track.addEventListener('scroll', () => {
        resetInitialPosition();
        this.update();
      }, { passive:true, signal });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        move((event.key === 'ArrowRight') !== rtl ? 1 : -1);
      }, { signal });
      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, [role="button"], product-form')) return;
        event.preventDefault();
        this.suppressClick = false;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, active: false };
      }, { signal });
      this.track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
      document.addEventListener('pointermove', (event) => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.active = true;
          this.suppressClick = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.track.scrollLeft = drag.left - dx;
      }, { signal, passive: false });
      const stopDrag = (event) => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
      };
      document.addEventListener('pointerup', stopDrag, { signal });
      document.addEventListener('pointercancel', stopDrag, { signal });
      this.track.addEventListener('click', (event) => {
        if (!this.suppressClick || event.detail === 0) return;
        this.suppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { signal, capture: true });
      this.observer = new ResizeObserver(() => {
        resetInitialPosition();
        this.update();
      });
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.controls.hidden = max <= 2;
      this.prev.disabled = position <= 2;
      this.next.disabled = position >= max - 2;
    }
    disconnectedCallback() {
      this.drag = null;
      this.track?.classList.remove('is-dragging');
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
